import React from "react";
import PropTypes from "prop-types";
import validator from "validate.js";
import { FORM_RULES } from "components/contact/form.validation";
import withAuth from "components/core/with-auth";
import NotificationBox from "components/elements/notification-box";
import SubmitButton from "components/elements/submit-button";
import Svg from "components/elements/svg";
import ValidatedInput from "components/elements/validated-input";
import getFormValues from "helpers/get-form-values";
import Api from "services/api";

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      submitState: 1,
      validationErrors: {},
      notification: {},
    };
  }

  handleSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const data = getFormValues(form);
    const validationErrors = validator(data, FORM_RULES, {
      fullMessages: false,
    });

    if (validationErrors) {
      this.setState({
        validationErrors,
      });

      return true;
    }

    if (this.state.submitState === 1) {
      this.setState({ submitState: 2 });
      this.api
        .post("/contact-form", data, this.props.tokens.token)
        .then((response) => {
          this.setState({
            submitState: 3,
            notification: {
              type: "success",
              message: response.message,
            },
          });
          form.reset();
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            notification: {
              type: "danger",
              message: error.message,
            },
            submitState: 4,
          });
        });
    }

    return true;
  }

  handleInputFocus(e) {
    const { validationErrors } = this.state;
    this.setState({
      validationErrors: { ...validationErrors, [e.target.name]: [] },
    });
  }

  handleInputBlur(e) {
    const { name } = e.target;

    if (FORM_RULES[name]) {
      const errors = validator.single(e.target.value, FORM_RULES[name]);

      if (errors) {
        const validationErrors = {
          ...this.state.validationErrors,
          [name]: errors,
        };
        this.setState({ validationErrors });
      }
    }
  }

  render() {
    const { submitState, validationErrors, notification } = this.state;
    return (
      <div
        className="contact-form"
        ref={(el) => {
          this.form = el;
        }}
      >
        <h2 className="section-heading">Send us a message</h2>

        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="accept-terms">
            <label htmlFor="acceptTerms">Accept rules</label>
            <input type="checkbox" name="acceptTerms" id="acceptTerms" />
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-4">
              <ValidatedInput errors={validationErrors.name}>
                <label className="required" htmlFor="name">
                  Full name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  required
                  onFocus={(e) => this.handleInputFocus(e)}
                  onBlur={(e) => this.handleInputBlur(e)}
                />
              </ValidatedInput>
            </div>
            <div className="col-xs-12 col-sm-4">
              <ValidatedInput errors={validationErrors.email}>
                <label className="required" htmlFor="email">
                  E-mail address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  required
                  onFocus={(e) => this.handleInputFocus(e)}
                  onBlur={(e) => this.handleInputBlur(e)}
                />
              </ValidatedInput>
            </div>
            <div className="col-xs-12 col-sm-4">
              <ValidatedInput errors={validationErrors.phone}>
                <label className="required" htmlFor="phone">
                  Phone number
                </label>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  required
                  onFocus={(e) => this.handleInputFocus(e)}
                  onBlur={(e) => this.handleInputBlur(e)}
                />
              </ValidatedInput>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <ValidatedInput errors={validationErrors.message}>
                <label className="required" htmlFor="message">
                  Your message
                </label>
                <textarea
                  name="message"
                  id="message"
                  required
                  rows="6"
                  className="form-control"
                  onFocus={(e) => this.handleInputFocus(e)}
                  onBlur={(e) => this.handleInputBlur(e)}
                />
              </ValidatedInput>
            </div>
          </div>
          <div className="row submit-row">
            <SubmitButton
              type="submit"
              state={submitState}
              className="btn btn-primary with-arrow"
              onUpdate={(newState) => this.setState({ submitState: newState })}
            >
              Submit
              <Svg className="arrow" src="arrow-right" />
            </SubmitButton>
          </div>
        </form>

        <NotificationBox type={notification.type}>
          {notification.message}
        </NotificationBox>
      </div>
    );
  }
}

ContactForm.propTypes = {
  tokens: PropTypes.shape({
    token: PropTypes.string,
  }).isRequired,
};

export default withAuth(ContactForm);
